module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h1', [_vm._v(_vm._s(_vm.yr))]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, _vm._l((_vm.siteReport), function(value, key) {
    return _c('tr', [_c('th', [_c('span', {
      class: _vm.titleClass(key)
    }, [_vm._v(_vm._s(key) + " Sites")]), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%",
        "font-weight": "normal"
      }
    }, [_vm._l((value), function(v, k) {
      return _c('tr', [_c('th', {
        attrs: {
          "width": "8%"
        }
      }, [_vm._v("Period")]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month1 ? v.month1.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month2 ? v.month2.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month3 ? v.month3.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month4 ? v.month4.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month5 ? v.month5.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month6 ? v.month6.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month7 ? v.month7.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month8 ? v.month8.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month9 ? v.month9.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month10 ? v.month10.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month11 ? v.month11.slice(0, 3) : ''))]), _vm._v(" "), _c('th', {
        attrs: {
          "width": _vm.width
        }
      }, [_vm._v(_vm._s(v.month12 ? v.month12.slice(0, 3) : ''))])])
    }), _vm._v(" "), _vm._l((value), function(v, k) {
      return _c('tr', [_vm._m(0, true), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites1 ? _vm.formatInteger(v.sites1) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites2 ? _vm.formatInteger(v.sites2) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites3 ? _vm.formatInteger(v.sites3) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites4 ? _vm.formatInteger(v.sites4) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites5 ? _vm.formatInteger(v.sites5) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites6 ? _vm.formatInteger(v.sites6) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites7 ? _vm.formatInteger(v.sites7) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites8 ? _vm.formatInteger(v.sites8) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites9 ? _vm.formatInteger(v.sites9) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites10 ? _vm.formatInteger(v.sites10) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites11 ? _vm.formatInteger(v.sites11) : ''))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.sites12 ? _vm.formatInteger(v.sites12) : ''))])])
    }), _vm._v(" "), _vm._l((value), function(v, k) {
      return _c('tr', [_c('td', [_vm._v("Ways")]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways1 ? _vm.formatInteger(v.ways1, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways2 ? _vm.formatInteger(v.ways2, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways3 ? _vm.formatInteger(v.ways3, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways4 ? _vm.formatInteger(v.ways4, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways5 ? _vm.formatInteger(v.ways5, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways6 ? _vm.formatInteger(v.ways6, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways7 ? _vm.formatInteger(v.ways7, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways8 ? _vm.formatInteger(v.ways8, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways9 ? _vm.formatInteger(v.ways9, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways10 ? _vm.formatInteger(v.ways10, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways11 ? _vm.formatInteger(v.ways11, 0) : ''))]), _vm._v(" "), _c('td', {
        staticClass: "text-primary",
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(v.ways12 ? _vm.formatInteger(v.ways12, 0) : ''))])])
    })], 2)])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Sites")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8279886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/SitesReport.vue
// module id = 1636
// module chunks = 0